import { create_element } from 'src/js/utils';

const class_observer = new MutationObserver((entries) => {
    entries.forEach(entry => {
        if (entry.type !== "attributes" && entry.attributeName !== "class") return;
        entry.target.on_class_change();
    });
});

export default class Filter_Indicators {

    constructor(container){
        if( typeof container === 'string' ) {
            container = document.querySelector(container);
        }
        this.container = container;
    }
    
    register_buttons( elements ){

        if( typeof elements === 'string' ) {
            elements = document.querySelectorAll(elements);
        }
        
        elements.forEach(el=>{
            el.on_class_change = ()=>{
                if( el.classList.contains('selected') ) {
                    this.add(el.textContent, el, ()=>{
                        el.click(); // on remove click, toggle filter button
                    });
                }
                else {
                    this.remove(el);  
                }
            }
            class_observer.observe(el, {attributes: true})
        })
    }

    add(text, el, on_remove = null){
        const indicator = create_element({class_name: 'indicator', text, render: this.container});
        el.indicator = indicator;
        const remove_button = create_element({class_name: 'remove', render: indicator});
        remove_button.addEventListener('click', ()=>{
            indicator.remove();
            if( typeof on_remove === 'function' ) {
                on_remove()
            }
        });
    }

    remove(el){
        el.indicator.remove();
    }

    

}